export enum PriorityCode {
  HIGH = 'HIGH',
  NORM = 'NORM',
}
